module.exports = __webpack_public_path__ + "img/index5.0a19da13.png";